export default __webpack_public_path__ + "static/media/prisma.e2154187.png";